import {api} from "@/shared/api";
import {FormUtil} from "@/shared/forms/formUtil";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";

export class DeleteAccountPage {
	private readonly deleteAccountLabel = $("#deleteAccountAgreedLabel");
	private readonly deleteAccountCheckbox = $("#deleteAccountAgreed");
	private readonly deleteAccountButton = $("#deleteAccountButton");
	private readonly cancelButton = $("#cancelButton");
	private readonly form = $("#deleteAccountForm");

	constructor() {
		this.loadUserCount();
		this.registerEventHandlers();
	}

	private loadUserCount() {
		api("admin/countAllUsers.json")
			.get()
			.then((count: number) => {
				if (count > 1) {
					this.deleteAccountLabel.append(messages.withArguments("admin.account.delete.agreement", count));
				} else {
					this.deleteAccountLabel.append(messages["admin.account.delete.agreement.single"]);
				}
			})
			.fail(() => this.deleteAccountLabel.append(messages.withArguments("admin.account.delete.agreement", "")));
	}

	private registerEventHandlers() {
		this.deleteAccountCheckbox.on("change", event => {
			const agreed = $(event.target).is(":checked");
			this.deleteAccountButton.prop("disabled", !agreed);
		});

		this.deleteAccountButton.on("click", event => {
			event.preventDefault();
			this.confirmDeleteAccount();
		});
	}

	private confirmDeleteAccount() {
		BootstrapModal.confirm({
			title: "admin.account.deleteAccountConfirmDialog.title",
			message: "admin.account.deleteAccountConfirmDialog.message",
			yesLabel: "admin.account.deleteAccountConfirmDialog.yesLabel",
			noLabel: "dialog.cancel",
			yesAction: modal => {
				modal.close();
				FormUtil.loading(this.form);
				this.cancelButton.addClass("disabled");
				this.form.submit();
			}
		});
	}
}
